import React, { Component } from 'react'
import { Row, Col, Table, Icon, Popconfirm } from 'antd'
import IssuesModel from '../models/IssuesModel'
import { Link } from 'react-router-dom'
import AuthModel from '../models/AuthModel'
import moment from 'moment'

import Permissions from '../models/Permissions'

class PublicSearchResults extends Component {

    onExportPDF(id, e) {
        e.preventDefault();
        var format = 'MROL_' + id +'.pdf';
        var mime = 'application/pdf';
        var url = IssuesModel.endpoint() + '/search/export/' + format + '?token=' + AuthModel.getAuthToken()
        url += '&id=' + id;
        IssuesModel.download(format, url, mime, () => {})
    }

    getSubmitedLabel(item) {
        var label = '';
        switch(item.tecnico) {
            case 'public': label = 'Público'; break;
            default: label = 'Técnico'; break;
        }
        return label;
    }

    render() {
        const role = Permissions.getUserRole();
        let items = this.props.items;
        const columns = [];
        columns.push({
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => parseInt(a.id, 10) - parseInt(b.id, 10),
            render: (v, r) => <Link to={'/details/'+r.id}>{r.id}</Link>
        });
        if (['superuser', 'apaadmin'].indexOf(role) > -1) {
            columns.push({
                title: 'Tipo',
                dataIndex: 'tecnico_utilizador_id',
                key: 'tecnico_utilizador_id',
                render: (text, r) => {
                    return this.getSubmitedLabel(r)
                },
                sorter: (a, b) => this.getSubmitedLabel(a) >= this.getSubmitedLabel(b) ? 1 : -1
            });
        } else {
            items = items.filter(i => this.getSubmitedLabel(i) === 'Técnico')
        }
        columns.push({
            title: 'Data da Ocorrência',
            dataIndex: 'data_ocorrencia',
            key: 'data_ocorrencia',
            sorter: (a, b) => moment(a.data_ocorrencia).isAfter(b.data_ocorrencia) ? 1 : -1,
            render: (text, r) => (
                r.data_ocorrencia_tipo === 0 ? text : 'Indeterminada'
            )
        });
        columns.push({
            title: 'Data do Registo',
            dataIndex: 'data_registo_local',
            key: 'data_registo_local',
            sorter: (a, b) => moment(a.data_registo_local).isAfter(b.data_registo_local) ? 1 : -1
        });
        columns.push({
            title: 'Data da Submissão',
            dataIndex: 'data_registo',
            key: 'data_registo',
            sorter: (a, b) => moment(a.data_registo).isAfter(b.data_registo) ? 1 : -1
        });
        columns.push({
            title: 'Entidade',
            dataIndex: 'entidade',
            key: 'entidade',
            sorter: (a, b) => a.entidade >= b.entidade ? 1 : -1
        });
        columns.push({
            title: 'Localização',
            dataIndex: 'concelho',
            key: 'concelho',
            sorter: (a, b) => {
                var aStr = a.concelho
                var bStr = b.concelho
                return aStr >= bStr ? 1 : -1
            },
            render: (text, r) => (
                <span>{r.concelho}</span>
            )
        });
        columns.push({
            title: 'Praia',
            dataIndex: 'praia',
            key: 'praia',
            sorter: (a, b) => a.praia >= b.praia ? 1 : -1
        });
        columns.push({
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => a.status >= b.status ? 1 : -1,
            render: (text, r) => (
                <span>
                    { r.status === 'Guardada' ? (<Icon type="exclamation-circle-o" style={{color: 'orange'}} />)
                        : r.status === 'Anulada' ? (<Icon type="close-circle-o" style={{color: 'red'}} />)
                        : (<Icon type="check-circle-o" style={{color: 'green'}} />)
                    }
                    <span className="hide-small">{' '}{r.status}</span>
                </span>
            )
        });
        columns.push({
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Link to="" title="PDF" onClick={(e) => this.onExportPDF(record.id, e)}>
                      <Icon type="file" style={{color: 'black'}} />
                    </Link>
                    <Link to={'/details/' + record.id}>
                        <Icon type="folder-open" style={{color: 'green'}} />
                    </Link>
                    { !Permissions.isDenied('issues', 'update', record) ? (
                        <Link to={'/issue/' + record.id}>
                            <Icon type="edit" style={{color: 'blue'}} />
                        </Link>
                    ) : '' }
                    {' '}
                    { !Permissions.isDenied('issues', 'delete', record) ? (
                        <Popconfirm title="DESTRUIR? Não poderá voltar atrás."
                            onConfirm={(e) => this.props.remove(record)}
                            okText="Sim" cancelText="Não">
                            <a role="button">
                                <Icon type="delete" style={{color: 'red'}} />
                            </a>
                        </Popconfirm>
                    ) : '' }
                </span>
            )
        });
        items.map((item) => {
            item.key = item.id
            return item
        })
        return (
            <div id="searchResults" style={{marginTop: '20px'}}>
                <Row>
                    <Col xs={24} sm={24}>
                        <legend>Resultados da Pesquisa ({items.length})</legend>
                        <Table dataSource={items} columns={columns} onChange={this.props.onTableChange} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default PublicSearchResults;



// WEBPACK FOOTER //
// ./src/components/PublicSearchResults.js